let customizerTemplate = _.template(document.getElementById('product-customizer-template').innerHTML );
let swatchTemplate = _.template(document.getElementById('product-swatch-template').innerHTML );
let swatchGroupTemplate = _.template(document.getElementById('product-swatch-group-template').innerHTML );
let variationTemplate = _.template(document.getElementById('product-variation-template').innerHTML );
let subVariationTemplate = _.template(document.getElementById('product-sub-variation-template').innerHTML );
let subVariationListTemplate = _.template(document.getElementById('product-sub-variation-list-template').innerHTML );



export {customizerTemplate, swatchTemplate, variationTemplate, swatchGroupTemplate, subVariationTemplate, subVariationListTemplate};